export const Countries = Object.freeze({
  IN: {
    value: 'India',
    code: 'IN',
    key: '94',
  },
});

export const getNationalityOptions = () => Object.values(Countries).map((country) => ({
  id: country.code,
  text: country.value,
  obj: country,
}));
